import { useQuery } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { whenAuthenticated } from '@/utils/query-utils'
import { MaybeRef, toValue } from 'vue'

export const useConditionStatusAgeQuery = (
    plantSids: MaybeRef<number[]>,
    endDate: MaybeRef<string>,
    generatorAge: MaybeRef<number>,
) => {
    return useQuery({
        queryKey: ['generators', 'portfolioTrends', 'conditionStatusAge', plantSids, endDate, generatorAge],
        queryFn: async ({ signal }) => {
            const {
                data: { result },
            } = await hcaClientFactory.portfolioTrendsApi.getGeneratorStatusesByAge(
                toValue(endDate),
                toValue(plantSids),
                toValue(generatorAge),
                {
                    signal,
                },
            )
            return result
        },
        enabled: whenAuthenticated,
    })
}
